<template>
  <section class="accordion">
    <header class="accordion__header">
      <component :is="headingTag" class="accordion__heading">
        <button
          type="button"
          class="accordion__button"
          :aria-expanded="`${isExpanded}`"
          :aria-controls="contentId"
          @click="toggle"
        >
          <div>
            <span>{{ heading }}</span>
          </div>

          <dpc-icon
            class="accordion__icon"
            icon="arrow-down"
            :label-path="iconLabelPath"
          />
        </button>
      </component>
    </header>
    <u-transition-height>
      <!-- v-if="keepContentAlive || isExpanded" -->
      <div v-show="isExpanded" :id="contentId" class="accordion__content">
        <div class="accordion__inner">
          <dpc-scrollable
            v-if="hasScrollbar"
            :options="{
              className: 'os-theme-block-dark',
              sizeAutoCapable: true,
            }"
          >
            <div>
              <slot />
            </div>
          </dpc-scrollable>
          <div v-else>
            <slot />
          </div>
        </div>
      </div>
    </u-transition-height>
  </section>
</template>

<script>
import { ref, computed, readonly, inject, watch } from 'vue';
import { uuid } from 'vue-uuid';

export default {
  props: {
    heading: {
      type: String,
      required: true,
    },
    headingTag: {
      type: String,
      default: 'strong',
    },
    keepContentAlive: {
      type: Boolean,
      default: false,
    },
    hasScrollbar: {
      type: Boolean,
      default: false,
    },
    initialExpanded: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isExpanded = ref(props.initialExpanded);
    const id = readonly(ref(uuid.v1()));
    const contentId = computed(() => `accordion-${id.value}-content`);
    const iconLabelPath = computed(() =>
      isExpanded.value ? 'collapse' : 'expand'
    );
    const setCurrentId = inject('accordionList/setCurrentId', () => {});
    const currentId = inject('accordionList/currentId', ref(undefined));

    const close = () => {
      isExpanded.value = false;
    };

    const open = () => {
      isExpanded.value = true;
    };

    const toggle = () => {
      isExpanded.value = !isExpanded.value;
    };

    watch(isExpanded, isExpanded => {
      if (!isExpanded) return;
      setCurrentId(id.value);
    });

    watch(currentId, currentId => {
      currentId !== id.value ? close() : open();
    });

    return { isExpanded, contentId, iconLabelPath, toggle };
  },
};
</script>
